import { Component } from '@angular/core';
import { AuthenticationService } from './components/login/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Agribid Admin';
  constructor(public demoService: AuthenticationService){}
}
